"use strict";
/**
 * HR Enums — shared across backend and frontend.
 *
 * These enums were previously duplicated in both repos.
 * Single source of truth lives here in hvp-shared.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HRPaymentType = exports.CFDI_STATUS_LABELS = exports.CfdiStatus = exports.PAYROLL_STATUS_LABELS = exports.PayrollStatus = void 0;
var PayrollStatus;
(function (PayrollStatus) {
    PayrollStatus["Pending"] = "pending";
    PayrollStatus["Approved"] = "approved";
    PayrollStatus["Paid"] = "paid";
    PayrollStatus["Billed"] = "billed";
})(PayrollStatus || (exports.PayrollStatus = PayrollStatus = {}));
exports.PAYROLL_STATUS_LABELS = {
    [PayrollStatus.Pending]: "Pendiente",
    [PayrollStatus.Approved]: "Aprobada",
    [PayrollStatus.Paid]: "Pagada",
    [PayrollStatus.Billed]: "Facturada",
};
var CfdiStatus;
(function (CfdiStatus) {
    CfdiStatus["Pending"] = "pending";
    CfdiStatus["Ready"] = "ready";
    CfdiStatus["Stamped"] = "stamped";
    CfdiStatus["StampedExternal"] = "stamped_external";
    CfdiStatus["Cancelled"] = "cancelled";
    CfdiStatus["Error"] = "error";
})(CfdiStatus || (exports.CfdiStatus = CfdiStatus = {}));
exports.CFDI_STATUS_LABELS = {
    [CfdiStatus.Pending]: "Pendiente",
    [CfdiStatus.Ready]: "Lista",
    [CfdiStatus.Stamped]: "Timbrada",
    [CfdiStatus.StampedExternal]: "Timbrada (externo)",
    [CfdiStatus.Cancelled]: "Cancelada",
    [CfdiStatus.Error]: "Error",
};
var HRPaymentType;
(function (HRPaymentType) {
    HRPaymentType["HOURLY"] = "HOURLY";
    HRPaymentType["SALARY"] = "SALARY";
    HRPaymentType["INFORMAL"] = "INFORMAL";
})(HRPaymentType || (exports.HRPaymentType = HRPaymentType = {}));
